import { c as _c } from "react/compiler-runtime";
import { IImages } from "@shared/types";
import Image from "next/image";
import Marquee from "react-fast-marquee";
export function MarqueeImages(t0) {
  const $ = _c(7);
  const {
    sections,
    speed: t1
  } = t0;
  const speed = t1 === undefined ? 20 : t1;
  let t2;
  if ($[0] !== sections || $[1] !== speed) {
    let t3;
    if ($[3] !== speed) {
      t3 = (section, index) => {
        const direction = index % 2 === 0 ? "left" : "right";
        return <div key={index} className="overflow-hidden whitespace-nowrap w-full relative"><div className="fade-left pointer-events-none absolute left-0 top-0 h-full w-24 z-10" /><div className="fade-right pointer-events-none absolute right-0 top-0 h-full w-24 z-10" /><Marquee direction={direction} className="bg-white" speed={speed}>{section.logos?.data?.map(_temp)}</Marquee></div>;
      };
      $[3] = speed;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = sections.map(t3);
    $[0] = sections;
    $[1] = speed;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="flex flex-col gap-12 w-full">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(logo, i) {
  return <Image key={i} src={logo.attributes?.url || ""} alt={logo.attributes?.alternativeText || logo.attributes?.name || ""} width={200} height={56} className="object-contain h-10 sm:h-14 w-auto max-w-[268px] mx-6 md:mx-10" />;
}